import React from 'react';
import { Box } from '@mui/material';

const TOTAL_DAYS = 15;

const DateBar = ({ approvedDates = [], requestedDates = [] }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        border: '1px solid black',
        borderRadius: '4px',
        overflow: 'hidden',
      }}
    >
      {Array.from({ length: TOTAL_DAYS }).map((_, index) => {
        const isApproved = approvedDates.includes(index);
        const isRequested = requestedDates.includes(index);

        return (
          <Box
            key={index}
            sx={{
              flex: 1,
              height: 10,
              backgroundColor: isApproved
                ? 'green'
                : isRequested
                  ? 'orange'
                  : 'lightgray',
              borderRight: index < TOTAL_DAYS - 1 ? '1px solid black' : 'none',
            }}
          />
        );
      })}
    </Box>
  );
};

export default DateBar;
